var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseField',_vm._g(_vm._b({ref:"field",on:{"focus":_vm.onFieldFocus,"blur":_vm.onFieldBlur}},'BaseField',_vm.attributes,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }